import {getRequest} from "./config";

export const pingServerApi = () => {
    return new Promise((resolve, reject) => {
        getRequest(`ping`)
            .then(response => resolve(response.data.data))
            .catch(err => reject(err.response))
    })
}